// extracted by mini-css-extract-plugin
export default {"tooltip":"chart_tooltip__ipS+Y","critical":"chart_critical__2gKjc"};